import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { deleteRequest, getRequest, patchRequest, postRequest, ResponseDataType } from 'api';
import { Card, Row, Col, Table, TableProps, Button, Modal, Input, Space, List, InputNumber, Select, Popconfirm, Upload, Form } from 'antd';
import { DatePicker } from 'Components';
import { toast } from 'react-toastify';
import { ROLE, checkRole } from 'constant/role';
import { PlusOutlined, UploadOutlined, StopOutlined, CheckCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import styles from './import.module.css';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

import dayjs from 'dayjs';

// Component InputNumber tùy chỉnh với định dạng tiền tệ
const CurrencyInputNumber = ({ value, onChange, addonAfter, ...props }: any) => {
    return (
        <InputNumber
            {...props}
            value={value}
            onChange={onChange}
            addonAfter={addonAfter}
            placeholder="Nhập số tiền"
            formatter={(value) => {
                if (!value && value !== 0) return '';
                const numStr = value.toString();
                return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            }}
            parser={(value) => {
                if (!value) return '';
                return value.replace(/\./g, '');
            }}
            style={{ width: '100%' }}
        />
    );
};
interface InputFileStudent {
    file: any;
}

interface FormValueType {
    file: any;
}
interface ClassYearData {
    classYearId: number;
    className: string;
    classLevel: string;
    schoolName: string;
    schoolYear: string;
}

interface StudentData {
    studentId: number;
    name: string;
    dob: string;
    gender: number;
    studentCode: string;
    cmnd: string;
    parentPhonenum?: string;
    studentClassYearId?: number;
}
interface HomeroomTeacher {
    teacherId: number;
    fullName: string;
    dob: string;
    phoneNumber: string;
}
interface SubjectTeacher {
    teacherId: number;
    customerId: number;
    gender: number;
    fullName: string;
    dob: string;
    phoneNumber: string;
    email: string;
    address: string;
    currentStatus: number;
    contractType: number;
    schoolId: number;
}
interface IncomeSourceData {
    id: number;
    description: string;
    unitPrice: number;
    expectedUnits: number;
    actualUnits: number;
    createdDate: number[];
    updatedDate: number[];
    incomeSchoolId: number;
}
export const ClassYearInfo = ({ classYearId: propClassYearId }: { classYearId?: string | number }) => {
    const navigate = useNavigate();
    const [incomeModalVisible, setIncomeModalVisible] = useState(false);
    const [selectedStudentId, setSelectedStudentId] = useState<number | null>(null);

    const [incomeForm, setIncomeForm] = useState({
        unitType: 1,
        description: '',
        unitPrice: '',
        expectedUnits: ''
    });
    const [form] = Form.useForm();
    const [selectedIncome, setSelectedIncome] = useState<IncomeSourceData | null>(null);
    const [selectedType, setSelectedType] = useState<number | null>(null);
    const [incomeNames, setIncomeNames] = useState<string[]>([]);
    const [editForm] = Form.useForm();
    const [showEditClassModal, setShowEditClassModal] = useState(false);
    const [subjectTeachers, setSubjectTeachers] = useState<SubjectTeacher[]>([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [subjectTeacherSearchResults, setSubjectTeacherSearchResults] = useState<SubjectTeacher[]>([]);
    const [loadingSubjectSearch, setLoadingSubjectSearch] = useState(false);
    const isAdmin = checkRole(ROLE.ADMIN);
    const isAccountant = checkRole(ROLE.ACCOUNTANT);
    const [homeroomTeacher, setHomeroomTeacher] = useState<HomeroomTeacher[] | null>(null);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showAddTeacherModal, setShowAddTeacherModal] = useState(false);
    const [newTeacherEmail, setNewTeacherEmail] = useState('');
    const [teacherSearchResults, setTeacherSearchResults] = useState<any[]>([]);
    const [loadingTeacherSearch, setLoadingTeacherSearch] = useState(false);
    const [selectedIncomeType, setSelectedIncomeType] = useState<number | null>(null);
    const schoolId = Number(localStorage.getItem("schoolId"));

    const { classYearId: paramClassYearId } = useParams<{ classYearId: string }>();
    const classYearId = (propClassYearId || paramClassYearId)?.toString();
    const [classInfo, setClassInfo] = useState<ClassYearData | null>(null);
    const [absentStudents, setAbsentStudents] = useState<StudentData[]>([]);
    const [students, setStudents] = useState<StudentData[]>([]);
    const [studentKeyword, setStudentKeyword] = useState('');
    const [absentStudentKeyword, setAbsentStudentKeyword] = useState('');
    const [searchResults, setSearchResults] = useState<StudentData[]>([]);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [importform] = Form.useForm();

    // Selection states for bulk actions
    const [selectedStudyingKeys, setSelectedStudyingKeys] = useState<React.Key[]>([]);
    const [selectedStudyingRows, setSelectedStudyingRows] = useState<StudentData[]>([]);
    const [selectedAbsentKeys, setSelectedAbsentKeys] = useState<React.Key[]>([]);
    const [selectedAbsentRows, setSelectedAbsentRows] = useState<StudentData[]>([]);
    const [loadingBulkAction, setLoadingBulkAction] = useState<boolean>(false);

    const normalizeSearchText = (value?: string) => {
        return (value || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/đ/g, 'd')
            .replace(/Đ/g, 'D')
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .trim();
    };

    const hasVietnameseAccent = (value?: string) => {
        if (!value) return false;
        return value.normalize('NFD') !== value || /[đĐ]/.test(value);
    };

    const rawKeyword = (studentKeyword || '').toLowerCase().replace(/\s+/g, ' ').trim();
    const normalizedKeyword = normalizeSearchText(studentKeyword);
    const isAccentedStudentQuery = hasVietnameseAccent(studentKeyword);
    const filteredStudents = normalizedKeyword
        ? students.filter((student) => {
            const rawName = (student.name || '').toLowerCase().replace(/\s+/g, ' ').trim();
            const rawCmnd = (student.cmnd || '').toLowerCase().replace(/\s+/g, ' ').trim();
            const normalizedName = normalizeSearchText(student.name);
            const normalizedCmnd = normalizeSearchText(student.cmnd);

            const isRawMatch = rawName.includes(rawKeyword) || rawCmnd.includes(rawKeyword);
            const isNormalizedMatch = normalizedName.includes(normalizedKeyword) || normalizedCmnd.includes(normalizedKeyword);

            return isAccentedStudentQuery ? isRawMatch : (isRawMatch || isNormalizedMatch);
        })
        : students;

    const rawAbsentKeyword = (absentStudentKeyword || '').toLowerCase().replace(/\s+/g, ' ').trim();
    const normalizedAbsentKeyword = normalizeSearchText(absentStudentKeyword);
    const isAccentedAbsentQuery = hasVietnameseAccent(absentStudentKeyword);
    const filteredAbsentStudents = normalizedAbsentKeyword
        ? absentStudents.filter((student) => {
            const rawName = (student.name || '').toLowerCase().replace(/\s+/g, ' ').trim();
            const rawCmnd = (student.cmnd || '').toLowerCase().replace(/\s+/g, ' ').trim();
            const normalizedName = normalizeSearchText(student.name);
            const normalizedCmnd = normalizeSearchText(student.cmnd);

            const isRawMatch = rawName.includes(rawAbsentKeyword) || rawCmnd.includes(rawAbsentKeyword);
            const isNormalizedMatch = normalizedName.includes(normalizedAbsentKeyword) || normalizedCmnd.includes(normalizedAbsentKeyword);

            return isAccentedAbsentQuery ? isRawMatch : (isRawMatch || isNormalizedMatch);
        })
        : absentStudents;

    useEffect(() => {
        if (classYearId) {
            fetchClassInfo(classYearId);
            fetchStudentsInClass(classYearId);
            fetchHomeroomTeacher(classYearId);
            fetchSubjectTeachers(classYearId);
            fetchAbsentStudentsInClass(classYearId);
        }
    }, [classYearId]);

    const fetchClassInfo = async (id: string) => {
        const response: ResponseDataType<ClassYearData> = await getRequest(`/cms/class/get-class-year-info?classYearId=${id}`);
        if (response?.code === 200 && response.info) {
            setClassInfo(response.info);
        } else {
            toast.error('Không thể tải thông tin lớp học');
        }
    };
    const fetchSubjectTeachers = async (id: string) => {
        try {
            const res: ResponseDataType<any> = await getRequest(`/cms/teacher/get-subject-teacher-by-class-year?classYearId=${id}`);
            if (res?.code === 200 && Array.isArray(res.info) && res.info.length > 0) {
                setSubjectTeachers(res.info);
            } else {
                setSubjectTeachers([]);
            }
        } catch (error) {
            toast.error("Lỗi khi tải danh sách giáo viên bộ môn");
        }
    };
    const fetchHomeroomTeacher = async (id: string) => {
        const response: ResponseDataType<any> = await getRequest(`/cms/teacher/get-homeroom-teacher-by-class-year?classYearId=${id}`);
        if (response?.code === 200 && Array.isArray(response.info) && response.info.length > 0) {
            setHomeroomTeacher(response.info);
        } else {
            setHomeroomTeacher(null);
        }
    };
    const HandleInputFile = (value: FormValueType) => {
        Modal.confirm({
            style: { fontFamily: 'Quicksand' },
            title: 'Xác nhận thêm tệp.',
            async onOk() {
                try {
                    const formData = new FormData();
                    formData.append('file', value.file[0].originFileObj);

                    const apiUrl = `/cms/class/${classYearId}/import-students`;
                    const response: ResponseDataType<InputFileStudent> = await postRequest(apiUrl, formData, 'form-data');

                    if (response?.code === 200) {
                        toast.success('Thêm tệp thành công!');
                        fetchStudentsInClass(classYearId!);
                        setIsModalOpen(false);

                    } else {
                        toast.error('Thêm tệp thất bại!');
                    }
                } catch (error) {
                    console.error(error);
                    toast.error('Lỗi khi import tệp!');
                }
            },
        });
    };
    const endStudentClassYear = async (studentId: number) => {
        // Gọi API lấy studentClassYearId
        const studentClassYearRes: ResponseDataType<number> = await getRequest(
            `/cms/class/get-student-class-year-by-student-and-class-year?classYearId=${classYearId}&studentId=${studentId}`
        );

        if (studentClassYearRes?.code === 200 && studentClassYearRes.info) {
            const studentClassYearId = studentClassYearRes.info;

            // Gọi API kết thúc năm học
            const endYearRes: ResponseDataType<any> = await postRequest(
                `/cms/class/student-end-class-year?studentClassYearIds=${studentClassYearId}`,
                {}
            );

            if (endYearRes?.code === 200) {
                toast.success('Kết thúc năm học thành công');
                fetchStudentsInClass(classYearId!);
                fetchAbsentStudentsInClass(classYearId!);

            } else {
                toast.error('Kết thúc năm học thất bại');
            }
        } else {
            toast.error('Không tìm thấy studentClassYearId');
        }
    };
    const startStudentClassYear = async (studentId: number) => {
        // Gọi API lấy studentClassYearId
        const studentClassYearRes: ResponseDataType<number> = await getRequest(
            `/cms/class/get-student-class-year-by-student-and-class-year?classYearId=${classYearId}&studentId=${studentId}`
        );

        if (studentClassYearRes?.code === 200 && studentClassYearRes.info) {
            const studentClassYearId = studentClassYearRes.info;

            // Gọi API kết thúc năm học
            const endYearRes: ResponseDataType<any> = await postRequest(
                `/cms/class/student-start-class-year?studentClassYearIds=${studentClassYearId}`,
                {}
            );

            if (endYearRes?.code === 200) {
                toast.success('Thêm lại học sinh thành công');
                fetchStudentsInClass(classYearId!);
                fetchAbsentStudentsInClass(classYearId!);

            } else {
                toast.error('Kết thúc năm học thất bại');
            }
        } else {
            toast.error('Không tìm thấy studentClassYearId');
        }
    };

    // Bulk action: Dừng học hàng loạt
    const handleBulkEndStudying = () => {
        if (!selectedStudyingRows.length) {
            toast.warning('Vui lòng chọn ít nhất một học sinh');
            return;
        }

        Modal.confirm({
            title: `Xác nhận dừng học cho ${selectedStudyingRows.length} học sinh đã chọn?`,
            content: 'Các học sinh này sẽ được chuyển sang danh sách học sinh đã nghỉ.',
            okText: 'Xác nhận',
            okType: 'primary',
            cancelText: 'Hủy',
            async onOk() {
                setLoadingBulkAction(true);
                try {
                    const ids: number[] = [];
                    for (const student of selectedStudyingRows) {
                        if (student.studentClassYearId) {
                            ids.push(student.studentClassYearId);
                        } else {
                            const res = await getRequest(
                                `/cms/class/get-student-class-year-by-student-and-class-year?classYearId=${classYearId}&studentId=${student.studentId}`
                            );
                            if (res?.code === 200 && res.info) {
                                ids.push(res.info);
                            }
                        }
                    }

                    if (!ids.length) {
                        toast.error('Không tìm thấy thông tin lớp năm học của học sinh');
                        setLoadingBulkAction(false);
                        return;
                    }

                    const endYearRes: ResponseDataType<any> = await postRequest(
                        `/cms/class/student-end-class-year?studentClassYearIds=${ids.join(',')}`,
                        {}
                    );

                    if (endYearRes?.code === 200) {
                        toast.success(`Đã dừng học thành công cho ${ids.length} học sinh!`);
                        setSelectedStudyingKeys([]);
                        setSelectedStudyingRows([]);
                        fetchStudentsInClass(classYearId!);
                        fetchAbsentStudentsInClass(classYearId!);
                    } else {
                        toast.error(endYearRes?.msg || 'Dừng học thất bại');
                    }
                } catch (error) {
                    toast.error('Có lỗi xảy ra khi thực hiện dừng học');
                } finally {
                    setLoadingBulkAction(false);
                }
            },
        });
    };

    // Bulk action: Học lại hàng loạt
    const handleBulkStartStudying = () => {
        if (!selectedAbsentRows.length) {
            toast.warning('Vui lòng chọn ít nhất một học sinh');
            return;
        }

        Modal.confirm({
            title: `Xác nhận cho ${selectedAbsentRows.length} học sinh đi học lại?`,
            content: 'Các học sinh này sẽ được chuyển trở lại danh sách học sinh đang học.',
            okText: 'Xác nhận',
            okType: 'primary',
            cancelText: 'Hủy',
            async onOk() {
                setLoadingBulkAction(true);
                try {
                    const ids: number[] = [];
                    for (const student of selectedAbsentRows) {
                        if (student.studentClassYearId) {
                            ids.push(student.studentClassYearId);
                        } else {
                            const res = await getRequest(
                                `/cms/class/get-student-class-year-by-student-and-class-year?classYearId=${classYearId}&studentId=${student.studentId}`
                            );
                            if (res?.code === 200 && res.info) {
                                ids.push(res.info);
                            }
                        }
                    }

                    if (!ids.length) {
                        toast.error('Không tìm thấy thông tin lớp năm học của học sinh');
                        setLoadingBulkAction(false);
                        return;
                    }

                    const startYearRes: ResponseDataType<any> = await postRequest(
                        `/cms/class/student-start-class-year?studentClassYearIds=${ids.join(',')}`,
                        {}
                    );

                    if (startYearRes?.code === 200) {
                        toast.success(`Đã thêm lại ${ids.length} học sinh vào lớp thành công!`);
                        setSelectedAbsentKeys([]);
                        setSelectedAbsentRows([]);
                        fetchStudentsInClass(classYearId!);
                        fetchAbsentStudentsInClass(classYearId!);
                    } else {
                        toast.error(startYearRes?.msg || 'Học lại thất bại');
                    }
                } catch (error) {
                    toast.error('Có lỗi xảy ra khi thực hiện cho học lại');
                } finally {
                    setLoadingBulkAction(false);
                }
            },
        });
    };

    // Bulk action: Xóa khỏi lớp hàng loạt
    const handleBulkDeleteStudents = (targetRows: StudentData[], isStudying: boolean) => {
        if (!targetRows.length) {
            toast.warning('Vui lòng chọn ít nhất một học sinh để xóa');
            return;
        }

        Modal.confirm({
            title: `Bạn có chắc chắn muốn xóa ${targetRows.length} học sinh đã chọn khỏi lớp?`,
            content: 'Hành động này không thể hoàn tác.',
            okText: 'Xóa',
            okType: 'danger',
            cancelText: 'Hủy',
            async onOk() {
                setLoadingBulkAction(true);
                let successCount = 0;
                let failHasIncomeCount = 0;
                let failOtherCount = 0;

                for (const student of targetRows) {
                    try {
                        const res: ResponseDataType<{}> = await deleteRequest(
                            `/cms/class/${classYearId}/delete-studentClassYear`,
                            { studentId: student.studentId }
                        );
                        if (res?.code === 200) {
                            successCount++;
                        } else if (res?.msg?.includes('income student register records')) {
                            failHasIncomeCount++;
                        } else {
                            failOtherCount++;
                        }
                    } catch (e) {
                        failOtherCount++;
                    }
                }

                if (successCount > 0) {
                    toast.success(`Đã xóa thành công ${successCount} học sinh khỏi lớp!`);
                }
                if (failHasIncomeCount > 0) {
                    toast.error(`${failHasIncomeCount} học sinh không thể xóa do còn nguồn thu/biên lai.`);
                }
                if (failOtherCount > 0) {
                    toast.error(`${failOtherCount} học sinh xóa thất bại.`);
                }

                if (isStudying) {
                    setSelectedStudyingKeys([]);
                    setSelectedStudyingRows([]);
                } else {
                    setSelectedAbsentKeys([]);
                    setSelectedAbsentRows([]);
                }

                fetchStudentsInClass(classYearId!);
                fetchAbsentStudentsInClass(classYearId!);
                setLoadingBulkAction(false);
            },
        });
    };

    const studyingRowSelection = {
        selectedRowKeys: selectedStudyingKeys,
        onChange: (keys: React.Key[], rows: StudentData[]) => {
            setSelectedStudyingKeys(keys);
            setSelectedStudyingRows(rows);
        },
    };

    const absentRowSelection = {
        selectedRowKeys: selectedAbsentKeys,
        onChange: (keys: React.Key[], rows: StudentData[]) => {
            setSelectedAbsentKeys(keys);
            setSelectedAbsentRows(rows);
        },
    };

    const handleAddSubjectTeacher = async (teacherId: number) => {
        try {
            const res = await postRequest(`/cms/class/${classYearId}/add-teacher-to-class-year?role=2`, {
                teacherId,
            });
            if (res?.code === 200) {
                toast.success("Đã thêm giáo viên bộ môn");
                fetchSubjectTeachers(classYearId!);
                setShowAddModal(false);
                // setSubjectTeacherSearchResults([]);
            } else {
                toast.error(res?.msg || "Thêm thất bại");
            }
        } catch (err) {
            toast.error("Lỗi khi gọi API thêm giáo viên");
        }
    };
    const handleAddTeacher = async (teacherId: number) => {
        const response = await postRequest(
            `/cms/class/${classYearId}/add-teacher-to-class-year?role=1`,
            { teacherId }
        );

        if (response?.code === 200) {
            toast.success('Đã thêm giáo viên chủ nhiệm');
            setShowAddTeacherModal(false);
            fetchHomeroomTeacher(classYearId!);
        } else {
            toast.error(response?.msg || 'Thêm giáo viên thất bại');
        }
    };
    const handleDeleteTeacher = async (teacherId: number) => {
        try {
            const res = await deleteRequest(`/cms/class/${classYearId}/delete-teacher-to-class-year?role=2`, {
                teacherId,
            });
            if (res?.code === 200) {
                toast.success("Đã xóa giáo viên bộ môn");
                fetchSubjectTeachers(classYearId!);
            } else {
                toast.error(res?.msg || "Xóa thất bại");
            }
        } catch (err) {
            toast.error("Lỗi khi gọi API xóa giáo viên");
        }
    };

    const fetchAbsentStudentsInClass = async (id: string) => {
        const response: ResponseDataType<{ list: StudentData[] }> = await getRequest(`/cms/student/get-students-by-class-year?classYearId=${id}&status=0`);
        if (response?.code === 200 && response.info && Array.isArray(response.info.list)) {
            setAbsentStudents(response.info.list);
        } else {
            setAbsentStudents([]);
            toast.error('Không thể tải danh sách học sinh');
        }
    };

    const fetchStudentsInClass = async (id: string) => {
        const response: ResponseDataType<{ list: StudentData[] }> = await getRequest(`/cms/student/get-students-by-class-year?classYearId=${id}&status=1`);
        if (response?.code === 200 && response.info && Array.isArray(response.info.list)) {
            setStudents(response.info.list);
        } else {
            setStudents([]);
            toast.error('Không thể tải danh sách học sinh');
        }
    };
    const handleCreateIncome = async () => {
        try {
            const values = await form.validateFields();
            if (!classYearId) return;
            const valuess = await form.validateFields();
            const selectedMonthYear = valuess.monthYear;
            const payload = {
                ...values,
                month: selectedMonthYear.month() + 1,
                year: selectedMonthYear.year(),
                actualUnits: values.expectedUnits,
                status: 0,
            };

            const res = await postRequest(
                `/cms/accountant/income-student-register/class-year/${classYearId}`,
                payload
            );

            if (res.code === 200) {
                toast.success("Tạo nguồn thu thành công");
                setIncomeModalVisible(false);
                form.resetFields();

                // Gọi lại API để reload danh sách sau khi thêm
                fetchStudentsInClass?.(classYearId);
            } else {
                toast.error(res.msg || "Tạo nguồn thu thất bại");
            }
        } catch (error) {
            toast.error("Vui lòng kiểm tra lại thông tin");
        }
    };


    const handleSearchTeacherByEmail = async (email: string) => {
        const schoolId = localStorage.getItem('schoolId');
        if (!schoolId) {
            toast.error('Không tìm thấy schoolId');
            return;
        }

        setLoadingTeacherSearch(true);
        const response: ResponseDataType<{ teacherId: number; fullName: string }[]> =
            await getRequest(`/cms/teacher/get-teacher-by-email-and-schoolId?email=${email}&schoolId=${schoolId}`);

        if (response?.code === 200 && Array.isArray(response.info)) {
            setTeacherSearchResults(response.info);
        } else {
            toast.error(response?.msg || 'Không tìm thấy giáo viên');
            setTeacherSearchResults([]);
        }
        setLoadingTeacherSearch(false);
    };


    const handleSearchSubjectTeacherByEmail = async (email: string) => {
        const schoolId = localStorage.getItem('schoolId');
        if (!schoolId) {
            toast.error('Không tìm thấy schoolId');
            return;
        }

        setLoadingSubjectSearch(true);

        const response: ResponseDataType<SubjectTeacher[]> = await getRequest(
            `/cms/teacher/get-teacher-by-email-and-schoolId?email=${email}&schoolId=${schoolId}`
        );

        if (response?.code === 200 && Array.isArray(response.info)) {
            setSubjectTeacherSearchResults(response.info);
        } else {
            toast.error(response?.msg || 'Không tìm thấy giáo viên');
            setSubjectTeacherSearchResults([]);
        }

        setLoadingSubjectSearch(false);
    };





    const handleUpdateHomeroomTeacher = async (teacherId: number) => {
        try {
            if (Array.isArray(homeroomTeacher) && homeroomTeacher.length > 0) {
                for (const teacher of homeroomTeacher) {
                    const deleteResponse = await deleteRequest(
                        `/cms/class/${classYearId}/delete-teacher-to-class-year?role=1`,
                        { teacherId: teacher.teacherId }
                    );

                    if (deleteResponse?.code !== 200) {
                        toast.error(deleteResponse?.msg || 'Không thể xoá giáo viên cũ');
                        return;
                    }
                }
            }

            const addResponse = await postRequest(
                `/cms/class/${classYearId}/add-teacher-to-class-year?role=1`,
                { teacherId }
            );

            if (addResponse?.code === 200) {
                toast.success('Cập nhật giáo viên chủ nhiệm thành công');
                setShowUpdateModal(false);
                fetchHomeroomTeacher(classYearId!);
            } else {
                toast.error(addResponse?.msg || 'Không thể thêm giáo viên mới');
            }
        } catch (err) {
            toast.error('Đã xảy ra lỗi khi cập nhật giáo viên chủ nhiệm');
        }
    };


    const handleDeleteStudent = async (studentId: number) => {
        const response: ResponseDataType<{}> = await deleteRequest(`/cms/class/${classYearId}/delete-studentClassYear`, { studentId });

        if (response?.code === 200) {
            toast.success('Xoá học sinh thành công');
            fetchStudentsInClass(classYearId!);
        } else {
            if (response?.msg?.includes('income student register records')) {
                toast.error('Không thể xoá vì học sinh này vẫn còn các khoản thu trong năm học.');
            } else {
                toast.error(response?.msg || 'Xoá học sinh thất bại');
            }
        }
    };

    const handleSearchByCMND = async (cmnd: string) => {
        if (!cmnd || cmnd.length < 3) {
            toast.warning('Vui lòng nhập CCCD hợp lệ');
            return;
        }

        setLoadingSearch(true);
        const response: ResponseDataType<StudentData> = await getRequest(`/cms/student/get-student-by-cmnd?cmnd=${cmnd}`);
        if (response?.code === 200 && response.info) {
            setSearchResults([response.info]);
        } else {
            setSearchResults([]);
            toast.error(response?.msg || 'Không tìm thấy học sinh');
        }
        setLoadingSearch(false);
    };
    const handleIncomeTypeChange = (value: number) => {
        setSelectedType(value);
        setSelectedIncomeType(value);
        setIncomeNames([]);
        form.setFieldsValue({
            type: value,
            incomeName: undefined,
            incomeSchoolId: undefined,
        });
        handleTypeChange(value); // ⬅️ RẤT QUAN TRỌNG
    };
    const handleTypeChange = async (type: number) => {
        setIncomeNames([]);
        try {
            const res = await getRequest(`/cms/accountant/income-school/get-income-school-by-school-and-type?schoolId=${schoolId}&type=${type}`);
            if (res.code === 200 && Array.isArray(res.info)) {
                setIncomeNames(res.info.map((item: any) => item.name));
            } else {
                setIncomeNames([]);
                toast.error("Không thể tải danh sách tên nguồn thu");
            }
        } catch (e) {
            setIncomeNames([]);
            toast.error("Lỗi khi tải tên nguồn thu");
        }
    };
    const handleAddStudent = async (studentId: number) => {
        const response = await postRequest(`/cms/class/${classYearId}/add-student-to-class-year`, { studentId });

        if (response?.code === 200) {
            toast.success('Đã thêm học sinh');
            fetchStudentsInClass(classYearId!);
            setShowModal(false);
        } else {
            toast.error(response?.msg || 'Thêm học sinh thất bại');
        }
    };
    const handleNameChange = async (name: string) => {
        console.log("changed", name);


        try {
            const res = await getRequest(`/cms/accountant/income-school/get-income-school-by-name-and-school?schoolId=${schoolId}&name=${encodeURIComponent(name)}`);
            if (res.code === 200 && res.info?.id) {
                form.setFieldsValue({ incomeSchoolId: res.info.id });
            } else {
                toast.error("Không tìm thấy incomeSchoolId");
            }
        } catch (e) {
            toast.error("Lỗi khi lấy incomeSchoolId");
        }
    };
    const columns: TableProps<StudentData>['columns'] = [
        { title: 'STT', key: 'stt', width: 45, align: 'center', render: (_, __, index) => index + 1 },
        { title: 'ID', dataIndex: 'studentId', key: 'studentId', width: 55, align: 'center' },
        {
            title: 'Họ tên',
            dataIndex: 'name',
            key: 'name',
            width: 160,
            align: 'left',
            render: (name) => <span style={{ fontWeight: 500 }}>{name}</span>,
        },
        { title: 'Ngày sinh', dataIndex: 'dob', key: 'dob', width: 95, align: 'center' },
        {
            title: 'Giới tính',
            dataIndex: 'gender',
            key: 'gender',
            width: 65,
            align: 'center',
            render: (gender) => (gender === 1 ? 'Nam' : 'Nữ'),
        },
        { title: 'Mã học sinh', dataIndex: 'studentCode', key: 'studentCode', width: 100, align: 'center' },
        { title: 'CCCD', dataIndex: 'cmnd', key: 'cmnd', width: 115, align: 'center' },
        { title: 'SĐT phụ huynh', dataIndex: 'parentPhonenum', key: 'parentPhonenum', width: 110, align: 'center' },
        {
            title: 'Hành động',
            key: 'action',
            width: 120,
            align: 'center',
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                    <span
                        style={{ color: '#fa8c16', cursor: 'pointer', whiteSpace: 'nowrap' }}
                        onClick={() => {
                            Modal.confirm({
                                title: 'Bạn có chắc chắn muốn kết thúc năm học của học sinh này?',
                                okText: 'Xác nhận',
                                okType: 'primary',
                                cancelText: 'Hủy',
                                onOk: () => endStudentClassYear(record.studentId),
                            });
                        }}
                    >
                        Dừng học
                    </span>
                    <span
                        style={{ color: '#ff4d4f', cursor: 'pointer', whiteSpace: 'nowrap' }}
                        onClick={() => {
                            Modal.confirm({
                                title: 'Bạn có chắc chắn muốn xoá học sinh này?',
                                okText: 'Xoá',
                                okType: 'danger',
                                cancelText: 'Hủy',
                                onOk: () => handleDeleteStudent(record.studentId),
                            });
                        }}
                    >
                        Xoá
                    </span>
                </div>
            ),
        },
    ];

    const columnss: TableProps<StudentData>['columns'] = [
        { title: 'STT', key: 'stt', width: 45, align: 'center', render: (_, __, index) => index + 1 },
        { title: 'ID', dataIndex: 'studentId', key: 'studentId', width: 55, align: 'center' },
        {
            title: 'Họ tên',
            dataIndex: 'name',
            key: 'name',
            width: 160,
            align: 'left',
            render: (name) => <span style={{ fontWeight: 500 }}>{name}</span>,
        },
        { title: 'Ngày sinh', dataIndex: 'dob', key: 'dob', width: 95, align: 'center' },
        {
            title: 'Giới tính',
            dataIndex: 'gender',
            key: 'gender',
            width: 65,
            align: 'center',
            render: (gender) => (gender === 1 ? 'Nam' : 'Nữ'),
        },
        { title: 'Mã học sinh', dataIndex: 'studentCode', key: 'studentCode', width: 100, align: 'center' },
        { title: 'CCCD', dataIndex: 'cmnd', key: 'cmnd', width: 115, align: 'center' },
        { title: 'SĐT phụ huynh', dataIndex: 'parentPhonenum', key: 'parentPhonenum', width: 110, align: 'center' },
        {
            title: 'Hành động',
            key: 'action',
            width: 120,
            align: 'center',
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                    <span
                        style={{ color: '#52c41a', cursor: 'pointer', whiteSpace: 'nowrap' }}
                        onClick={() => {
                            Modal.confirm({
                                title: 'Bạn có chắc chắn muốn thêm lại học sinh này vào lớp?',
                                okText: 'Xác nhận',
                                okType: 'primary',
                                cancelText: 'Hủy',
                                onOk: () => startStudentClassYear(record.studentId),
                            });
                        }}
                    >
                        Học lại
                    </span>
                    <span
                        style={{ color: '#ff4d4f', cursor: 'pointer', whiteSpace: 'nowrap' }}
                        onClick={() => {
                            Modal.confirm({
                                title: 'Bạn có chắc chắn muốn xoá học sinh này?',
                                okText: 'Xoá',
                                okType: 'danger',
                                cancelText: 'Hủy',
                                onOk: () => handleDeleteStudent(record.studentId),
                            });
                        }}
                    >
                        Xoá
                    </span>
                </div>
            ),
        },
    ];
    return (
        <div>
            <div style={{ backgroundColor: '#f5f8fa', padding: 16, borderRadius: 8, marginBottom: 24 }}>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <h3 style={{ margin: 0 }}>Thông tin chung</h3>
                    <Button
                        type="primary"
                        onClick={() => {
                            if (classInfo) {
                                editForm.setFieldsValue({
                                    className: classInfo.className,
                                    classLevel: classInfo.classLevel,
                                    schoolYear: classInfo.schoolYear,
                                });
                                setShowEditClassModal(true);
                            }
                        }}
                    >
                        Cập nhật thông tin lớp
                    </Button>
                </div>
                <Card style={{ marginBottom: 24 }}>
                    {classInfo ? (
                        <Row gutter={[16, 16]}>
                            <Col span={12}><strong>Tên lớp:</strong> {classInfo.className}</Col>
                            <Col span={12}><strong>Khối:</strong> {classInfo.classLevel}</Col>
                            <Col span={12}><strong>Năm học:</strong> {classInfo.schoolYear}</Col>
                            <Col span={12}><strong>Trường:</strong> {classInfo.schoolName}</Col>
                        </Row>
                    ) : <div>Đang tải thông tin lớp...</div>}
                </Card>
            </div>
            <Modal
                title="Cập nhật thông tin lớp"
                open={showEditClassModal}
                onCancel={() => setShowEditClassModal(false)}
                onOk={async () => {
                    try {
                        const values = await editForm.validateFields();

                        if (!classInfo) {
                            toast.error("Không có thông tin lớp để cập nhật");
                            return;
                        }

                        const payload = {
                            ...classInfo, // giữ nguyên tất cả thông tin cũ
                            classLevel: values.classLevel,
                            className: values.className,
                            schoolYear: values.schoolYear,
                            classYearID: Number(classYearId), // có thể đã có trong classInfo nhưng để chắc ăn
                        };

                        const result = await patchRequest(
                            "/cms/class/update-class-year",
                            payload
                        );

                        if (result?.code === 200) {
                            toast.success("Cập nhật lớp thành công");
                            setShowEditClassModal(false);
                            fetchClassInfo(classYearId!);
                        } else {
                            toast.error(result?.msg || "Cập nhật thất bại");
                        }
                    } catch (err) {
                        toast.error("Vui lòng nhập đầy đủ thông tin hợp lệ");
                    }
                }}

                okText="Lưu"
                cancelText="Hủy"
            >
                <Form form={editForm} layout="vertical">
                    <Form.Item label="Tên lớp" name="className" rules={[{ message: "Nhập tên lớp" }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Khối"
                        name="classLevel"

                    >
                        <Input placeholder="Nhập khối" />
                    </Form.Item>

                    <Form.Item label="Năm học" name="schoolYear" rules={[{ message: "Nhập năm học" }]}>
                        <Input placeholder="Ví dụ: Năm học 2025-2026" />
                    </Form.Item>
                </Form>
            </Modal>


            <div style={{ backgroundColor: '#f5f8fa', padding: 16, borderRadius: 8, marginBottom: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3>Thông tin giáo viên chủ nhiệm</h3>

                    <div style={{ marginBottom: 8 }}>
                        <Button type="primary" icon={<PlusOutlined />}
                            onClick={() => setShowAddTeacherModal(true)}>
                            Thêm giáo viên chủ nhiệm
                        </Button>

                    </div>
                </div>

                <Table

                    columns={[
                        { title: 'Họ tên', dataIndex: 'fullName', key: 'fullName', align: 'center' as const },
                        { title: 'Ngày sinh', dataIndex: 'dob', key: 'dob', align: 'center' as const },
                        { title: 'Số điện thoại', dataIndex: 'phoneNumber', key: 'phoneNumber', align: 'center' as const },

                        {
                            title: 'Hành động',
                            key: 'action',
                            align: 'center' as const,
                            render: (_: any, record: any) => (
                                <>
                                    <Button
                                        type="link"
                                        onClick={() => {

                                            setShowUpdateModal(true);
                                        }}
                                    >
                                        Cập nhật
                                    </Button>

                                    <Button
                                        type="link"
                                        danger
                                        onClick={() => {
                                            Modal.confirm({
                                                title: "Bạn có chắc chắn muốn xóa giáo viên chủ nhiệm này không?",
                                                content: "Hành động này không thể hoàn tác.",
                                                okText: "Xóa",
                                                cancelText: "Hủy",
                                                okType: "danger",

                                                async onOk() {
                                                    if (!classYearId || !record.teacherId) {
                                                        toast.error("Thiếu classYearId hoặc teacherId");
                                                        return;
                                                    }

                                                    try {
                                                        const res = await deleteRequest(
                                                            `/cms/class/${classYearId}/delete-teacher-to-class-year?role=1`,
                                                            { teacherId: record.teacherId }
                                                        );

                                                        if (res?.code === 200) {
                                                            toast.success("Đã xóa giáo viên chủ nhiệm");
                                                            fetchClassInfo(classYearId);
                                                            fetchHomeroomTeacher(classYearId);
                                                        } else {
                                                            toast.error(res?.msg || "Xóa thất bại");
                                                        }
                                                    } catch (err) {
                                                        toast.error("Lỗi khi gọi API xóa GVCN");
                                                    }
                                                }
                                            });
                                        }}
                                    >
                                        Xóa
                                    </Button>

                                </>
                            ),
                        },


                    ]}


                    dataSource={Array.isArray(homeroomTeacher) ? homeroomTeacher : []}
                    rowKey="teacherId"
                    pagination={false}
                    locale={{ emptyText: 'Chưa có giáo viên chủ nhiệm' }}
                />
            </div>


            <Modal
                title="Thêm giáo viên chủ nhiệm"
                open={showAddTeacherModal}
                onCancel={() => {
                    setShowAddTeacherModal(false);
                    setTeacherSearchResults([]);
                    setLoadingTeacherSearch(false);
                }}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập email giáo viên"
                    enterButton="Tìm kiếm"
                    loading={loadingTeacherSearch}
                    onSearch={handleSearchTeacherByEmail}
                />
                <List
                    style={{ marginTop: 16 }}
                    dataSource={teacherSearchResults}
                    bordered
                    renderItem={(item) => (
                        <List.Item
                            actions={[
                                <Button type="link" onClick={() => handleAddTeacher(item.teacherId)}>Thêm</Button>,
                            ]}
                        >
                            <Space direction="vertical">
                                <b>{item.fullName}</b>
                                <span>({item.email})</span>
                            </Space>
                        </List.Item>

                    )}
                />
            </Modal>
            <div style={{ backgroundColor: '#f5f8fa', padding: 16, borderRadius: 8, marginBottom: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0 }}>Danh sách giáo viên bộ môn</h3>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => setShowAddModal(true)}
                    >
                        Thêm giáo viên bộ môn
                    </Button>
                </div>
                <Table
                    columns={[
                        { title: 'Họ tên', dataIndex: 'fullName', key: 'fullName', align: 'center' as const },
                        { title: 'Ngày sinh', dataIndex: 'dob', key: 'dob', align: 'center' as const },
                        { title: 'Số điện thoại', dataIndex: 'phoneNumber', key: 'phoneNumber', align: 'center' as const },

                        {
                            title: 'Hành động',
                            key: 'action',

                            render: (_: any, record: SubjectTeacher) => (
                                <Button
                                    type="link"
                                    danger
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'Bạn có chắc chắn muốn xóa giáo viên này?',
                                            content: 'Hành động này không thể hoàn tác.',
                                            okText: 'Xóa',
                                            cancelText: 'Hủy',
                                            okType: 'danger',
                                            centered: true,
                                            onOk: async () => {
                                                await handleDeleteTeacher(record.teacherId);
                                            }
                                        });
                                    }}
                                >
                                    Xóa
                                </Button>
                            )
                        }

                    ]}
                    dataSource={subjectTeachers}
                    rowKey="teacherId"
                    pagination={false}
                    locale={{ emptyText: 'Chưa có giáo viên bộ môn' }}
                />


            </div>


            <Modal
                title="Thêm giáo viên bộ môn"
                open={showAddModal}
                onCancel={() => {
                    setShowAddModal(false);
                    setSubjectTeacherSearchResults([]);
                }}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập email giáo viên"
                    enterButton="Tìm kiếm"
                    loading={loadingSubjectSearch}
                    onSearch={handleSearchSubjectTeacherByEmail}
                />
                <List
                    dataSource={subjectTeacherSearchResults}
                    renderItem={(item: any, index) => (
                        <List.Item
                            key={index}
                            actions={[
                                <Button type="link" onClick={() => handleAddSubjectTeacher(item.teacherId)}>Thêm</Button>,
                            ]}
                        >
                            <Space direction="vertical">
                                <b>{item.fullName}</b>
                                <span>({item.email || 'Chưa có email'})</span>
                            </Space>
                        </List.Item>
                    )}
                />
            </Modal>
            <Modal
                title="Cập nhật giáo viên chủ nhiệm"
                open={showUpdateModal}
                onCancel={() => {
                    setShowUpdateModal(false);
                    setTeacherSearchResults([]);
                    setLoadingTeacherSearch(false);
                }}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập email giáo viên"
                    enterButton="Tìm kiếm"
                    loading={loadingTeacherSearch}
                    onSearch={handleSearchTeacherByEmail}
                />
                <List
                    style={{ marginTop: 16 }}
                    dataSource={teacherSearchResults}
                    bordered
                    renderItem={(item) => (
                        <List.Item actions={[<Button type="link" onClick={() => handleUpdateHomeroomTeacher(item.teacherId)}>Cập nhật</Button>]}>
                            <Space direction="vertical"><b>{item.fullName}</b></Space>
                        </List.Item>
                    )}
                />
            </Modal>

            <div style={{ backgroundColor: '#f5f8fa', padding: 16, borderRadius: 8, marginBottom: 24 }}>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 12,
                        flexWrap: 'wrap',
                        marginBottom: 16,
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                        <h3 style={{ margin: 0 }}>Danh sách học sinh đang học</h3>
                        <Input
                            allowClear
                            placeholder="Tìm theo họ tên hoặc CCCD"
                            value={studentKeyword}
                            onChange={(e) => setStudentKeyword(e.target.value)}
                            style={{ width: 320, maxWidth: '100%' }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        <Button type="primary" icon={<PlusOutlined />}
                            onClick={() => setShowModal(true)}>Thêm học sinh</Button>
                        <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
                            IMPORT FILE
                        </Button>
                    </div>
                </div>
                {selectedStudyingKeys.length > 0 && (
                    <div
                        style={{
                            backgroundColor: '#e6f7ff',
                            border: '1px solid #91d5ff',
                            borderRadius: 4,
                            padding: '4px 12px',
                            marginBottom: 6,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 6,
                        }}
                    >
                        <Space>
                            <span style={{ fontWeight: 500, color: '#096dd9' }}>
                                Đã chọn <b>{selectedStudyingKeys.length}</b> học sinh
                            </span>
                            <Button
                                type="link"
                                size="small"
                                onClick={() => {
                                    setSelectedStudyingKeys([]);
                                    setSelectedStudyingRows([]);
                                }}
                            >
                                Bỏ chọn
                            </Button>
                        </Space>
                        <Space>
                            <Button
                                icon={<StopOutlined />}
                                style={{ backgroundColor: '#fa8c16', borderColor: '#fa8c16', color: '#fff' }}
                                onClick={handleBulkEndStudying}
                                loading={loadingBulkAction}
                            >
                                Dừng học ({selectedStudyingKeys.length})
                            </Button>
                            <Button
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => handleBulkDeleteStudents(selectedStudyingRows, true)}
                                loading={loadingBulkAction}
                            >
                                Xóa khỏi lớp ({selectedStudyingKeys.length})
                            </Button>
                        </Space>
                    </div>
                )}
                <Table
                    rowSelection={studyingRowSelection}
                    columns={columns}
                    dataSource={filteredStudents}
                    rowKey="studentId"
                    pagination={false}
                    locale={{ emptyText: 'Không có học sinh nào' }}
                />

            </div>
            <div style={{ backgroundColor: '#f5f8fa', padding: 16, borderRadius: 8, marginBottom: 24 }}>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 12,
                        flexWrap: 'wrap',
                        marginBottom: 16,
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                        <h3 style={{ margin: 0 }}>Danh sách học sinh đã nghỉ</h3>
                        <Input
                            allowClear
                            placeholder="Tìm theo họ tên hoặc CCCD"
                            value={absentStudentKeyword}
                            onChange={(e) => setAbsentStudentKeyword(e.target.value)}
                            style={{ width: 320, maxWidth: '100%' }}
                        />
                    </div>
                </div>
                {selectedAbsentKeys.length > 0 && (
                    <div
                        style={{
                            backgroundColor: '#f6ffed',
                            border: '1px solid #b7eb8f',
                            borderRadius: 4,
                            padding: '4px 12px',
                            marginBottom: 6,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 6,
                        }}
                    >
                        <Space>
                            <span style={{ fontWeight: 500, color: '#389e0d' }}>
                                Đã chọn <b>{selectedAbsentKeys.length}</b> học sinh
                            </span>
                            <Button
                                type="link"
                                size="small"
                                onClick={() => {
                                    setSelectedAbsentKeys([]);
                                    setSelectedAbsentRows([]);
                                }}
                            >
                                Bỏ chọn
                            </Button>
                        </Space>
                        <Space>
                            <Button
                                icon={<CheckCircleOutlined />}
                                style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: '#fff' }}
                                onClick={handleBulkStartStudying}
                                loading={loadingBulkAction}
                            >
                                Học lại ({selectedAbsentKeys.length})
                            </Button>
                            <Button
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => handleBulkDeleteStudents(selectedAbsentRows, false)}
                                loading={loadingBulkAction}
                            >
                                Xóa khỏi lớp ({selectedAbsentKeys.length})
                            </Button>
                        </Space>
                    </div>
                )}
                <Table
                    rowSelection={absentRowSelection}
                    columns={columnss}
                    dataSource={filteredAbsentStudents}
                    rowKey="studentId"
                    pagination={false}
                    locale={{ emptyText: 'Không có học sinh nào' }}
                />

            </div>
            <Modal
                title="Nhập danh sách học sinh"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                destroyOnClose
            >
                <div style={{ marginBottom: '16px' }}>
                    <a href="/import/import_students_in_class_template.xlsx" download>
                        Tải file mẫu tại đây
                    </a>
                </div>
                <Form form={importform} onFinish={HandleInputFile} layout="vertical">
                    <Row>
                        <Col span={8}>
                            <div className={styles.card_content_label}>
                                <InsertDriveFileIcon />
                                &nbsp;&nbsp;File:
                            </div>
                        </Col>
                        <Col span={16}>
                            <Form.Item
                                name="file"
                                valuePropName="fileList"
                                getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
                                rules={[
                                    { required: true, message: 'Cần nhập file!' },
                                    {
                                        validator: (_, value) =>
                                            value && value.length > 0 && /\.(xlsx|xls)$/i.test(value[0].name)
                                                ? Promise.resolve()
                                                : Promise.reject(new Error('Chỉ chấp nhận file Excel!')),
                                    },
                                ]}
                            >
                                <Upload beforeUpload={() => false}>
                                    <Button icon={<UploadOutlined />}>Chọn file</Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Button type="primary" htmlType="submit" block>
                        IMPORT FILE
                    </Button>
                </Form>
            </Modal>
            <Modal
                title="Thêm nguồn thu cho tất cả học sinh"
                open={incomeModalVisible}
                onCancel={() => setIncomeModalVisible(false)}
                onOk={handleCreateIncome}
                okText="Thêm"
                cancelText="Hủy"
            >
                <Form layout="vertical" form={form}>
                    <Form.Item name="type" label="Loại nhóm thu" rules={[{ required: true }]}>
                        <Select placeholder="Chọn loại" onChange={handleIncomeTypeChange}>
                            <Select.Option value={1}>Nhóm ăn uống</Select.Option>
                            <Select.Option value={2}>Nhóm học phí</Select.Option>
                            <Select.Option value={3}>Nhóm học theo buổi (tiết)</Select.Option>
                            <Select.Option value={4}>Nhóm chi phí khác</Select.Option>
                            <Select.Option value={5}>Nhóm thu hộ</Select.Option>
                        </Select>
                    </Form.Item>

                    {selectedIncomeType === 1 && (
                        <>
                            <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                    {incomeNames.map((name) => (
                                        <Select.Option key={name} value={name}>{name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="incomeSchoolId" hidden>
                                <Input />
                            </Form.Item>



                            <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                <CurrencyInputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    addonAfter="VND/ngày"
                                />
                            </Form.Item>
                            <Form.Item name="expectedUnits" label="Số buổi dự kiến" rules={[{ required: true }]}>
                                <InputNumber style={{ width: '100%' }} min={1} />
                            </Form.Item>
                            <Form.Item name="monthYear" label="Tháng/Năm" rules={[{ required: true }]}>
                                <DatePicker picker="month" style={{ width: '100%' }} placeholder="Chọn tháng/năm" />
                            </Form.Item>

                            <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                        </>
                    )}

                    {selectedIncomeType === 2 && (
                        <>
                            <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                    {incomeNames.map((name) => (
                                        <Select.Option key={name} value={name}>{name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="incomeSchoolId" hidden>
                                <Input />
                            </Form.Item>
                            <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                <CurrencyInputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>
                            <Form.Item label="Đơn vị tính">
                                <Select
                                    placeholder="Chọn đơn vị tính"

                                    style={{ width: '100%' }}
                                >
                                    <Select.Option value="month">Theo tháng</Select.Option>
                                    <Select.Option value="semester">Theo kỳ (nửa năm học)</Select.Option>
                                    <Select.Option value="year">Theo năm học</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item name="expectedUnits" label="Số buổi dự kiến" rules={[{ required: true }]}>
                                <InputNumber style={{ width: '100%' }} min={1} />
                            </Form.Item>
                            <Form.Item name="monthYear" label="Tháng/Năm" rules={[{ required: true }]}>
                                <DatePicker picker="month" style={{ width: '100%' }} placeholder="Chọn tháng/năm" />
                            </Form.Item>

                            <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                        </>
                    )}
                    {selectedIncomeType === 3 && (
                        <>
                            <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                    {incomeNames.map((name) => (
                                        <Select.Option key={name} value={name}>{name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="incomeSchoolId" hidden>
                                <Input />
                            </Form.Item>



                            <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                <CurrencyInputNumber style={{ width: '100%' }} min={0} addonAfter="VND/buổi" />
                            </Form.Item>
                            <Form.Item name="expectedUnits" label="Số buổi dự kiến" rules={[{ required: true }]}>
                                <InputNumber style={{ width: '100%' }} min={1} />
                            </Form.Item>
                            <Form.Item name="monthYear" label="Tháng/Năm" rules={[{ required: true }]}>
                                <DatePicker picker="month" style={{ width: '100%' }} placeholder="Chọn tháng/năm" />
                            </Form.Item>

                            <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                        </>
                    )}{selectedIncomeType === 4 && (
                        <>
                            <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                    {incomeNames.map((name) => (
                                        <Select.Option key={name} value={name}>{name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="incomeSchoolId" hidden>
                                <Input />
                            </Form.Item>



                            <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                <CurrencyInputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>

                            <Form.Item name="monthYear" label="Tháng/Năm" rules={[{ required: true }]}>
                                <DatePicker picker="month" style={{ width: '100%' }} placeholder="Chọn tháng/năm" />
                            </Form.Item>

                            <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                        </>
                    )}{selectedIncomeType === 5 && (
                        <>
                            <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                    {incomeNames.map((name) => (
                                        <Select.Option key={name} value={name}>{name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="incomeSchoolId" hidden>
                                <Input />
                            </Form.Item>



                            <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                <CurrencyInputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>

                            <Form.Item name="monthYear" label="Tháng/Năm" rules={[{ required: true }]}>
                                <DatePicker picker="month" style={{ width: '100%' }} placeholder="Chọn tháng/năm" />
                            </Form.Item>

                            <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                        </>
                    )}
                    {/*
                                     <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                       <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                           {incomeNames.map((name) => (
                                               <Select.Option key={name} value={name}>{name}</Select.Option>
                                           ))}
                                       </Select>
                                   </Form.Item>
                                   <Form.Item name="incomeSchoolId" hidden>
                                       <Input />
                                   </Form.Item>


                                   <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                       <Input />
                                   </Form.Item>
                                   <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                       <InputNumber style={{ width: '100%' }} min={0} />
                                   </Form.Item>
                                   <Form.Item name="expectedUnits" label="Số buổi dự kiến" rules={[{ required: true }]}>
                                       <InputNumber style={{ width: '100%' }} min={1} />
                                   </Form.Item>
                                   <Form.Item name="month" label="Tháng" rules={[{ required: true }]}>
                                       <Select placeholder="Chọn tháng">
                                           {[...Array(12)].map((_, i) => (
                                               <Select.Option key={i + 1} value={i + 1}>
                                                   {`Tháng ${i + 1}`}
                                               </Select.Option>
                                           ))}
                                       </Select>
                                   </Form.Item>
                                   <Form.Item name="year" label="Năm" rules={[{ required: true }]}>
                                       <DatePicker picker="year" style={{ width: '100%' }} />
                                   </Form.Item> */}
                </Form>
            </Modal>




            <Modal
                title="Tìm học sinh bằng CCCD"
                open={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập CCCD học sinh"
                    enterButton="Tìm kiếm"
                    loading={loadingSearch}
                    onSearch={handleSearchByCMND}
                />
                <List
                    style={{ marginTop: 16 }}
                    dataSource={searchResults}
                    bordered
                    renderItem={(item) => (
                        <List.Item actions={[<Button type="link" onClick={() => handleAddStudent(item.studentId)}>Thêm</Button>]}>
                            <Space direction="vertical">
                                <div><b>{item.name}</b> ({item.studentCode})</div>
                                <div>{item.dob} - CCCD: {item.cmnd}</div>
                            </Space>
                        </List.Item>
                    )}
                />
            </Modal>
        </div>
    );
};
